<template>
  <naj-modal
    ref="addConcernedOfMinor"
    :title="local.lawsuitDetails.terminationsRequest.addConcerned"
    :width="1300"
    :footer="true"
    @onClose="onClose"
  >
    <personal-form
      v-if="showModal"
      ref="concernedOfMinorPersonalInfo"
      :title="local.personInformation.title"
      :form-model="formModel"
      :view-mode="viewMode"
      :required="true"
      :allow-address-check="true"
      :show-prisoner-form="false"
      :show-needs-translator-form="false"
    ></personal-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        v-if="!viewMode"
        :disabled="isSubmitDisabled"
        @click="submit(closeNajModal)"
      >
        {{
          submitButtonText
        }}
      </naj-button>
      <naj-button
        outlined
        @click="closeNajModal"
      >
        {{ local.common.cancel }}
      </naj-button>
    </template>
  </naj-modal>
</template>
<script>
import PersonalForm from '@/modules/lawsuit/components/step1/party-types/forms/personal-form';
import { partyTypeEnum } from '@/helpers/enum';
export default {
  name: 'AddConcernedOfMinorModal',
  components: { PersonalForm },
  inject: ['$validator'],
  props: ['showModal', 'selectedItem', 'viewMode'],
  data() {
    return { formModel: {} };
  },
  computed: {
    submitButtonText() {
      return this.formModel.objectKey ? this.local.common.save : this.local.common.add;
    },
    isFormEmpty() {
      return !Object.keys(this.formModel)
        .find(key => key != 'objectKey' && this.formModel[key]);
    },
    isSubmitDisabled() {
      return !this.formModel.objectKey && this.isFormEmpty;
    },
    isDeleteAction() {
      return this.formModel.objectKey && this.isFormEmpty;
    },
  },
  watch: {
    selectedItem(newValue) {
      newValue && (this.formModel = Object.assign({}, this.selectedItem));
    },
    showModal(newValue) {
      if (newValue) {
        this.$refs.addConcernedOfMinor.show();
      } else {
        this.$refs.addConcernedOfMinor.close();
      }
    },
  },
  methods: {
    submit(closeNajModal) {
      if (this.isDeleteAction) {
        this.$emit('deleteItem', this.formModel.objectKey);
        return;
      }
      this.formModel.objectKey ? this.updateItem() : this.addItem();
      closeNajModal();
    },
    addItem() {
      let fullname = `${this.formModel.firstName ? this.formModel.firstName + ' ' : ''}${this.formModel.fatherName ?
        this.formModel.fatherName + ' ' : ''}${this.formModel.grandFatherName ? this.formModel.grandFatherName + ' ' : ''}${this.formModel.familyName ? this.formModel.familyName : ''}`;
      this.$set(this.formModel, 'fullname', fullname || []);
      this.$set(this.formModel, 'partyTypeId', partyTypeEnum.person || []);
      this.$emit('addItem', this.formModel);
      this.formModel = {};
    },
    updateItem() {
      let fullname = `${this.formModel.firstName ? this.formModel.firstName + ' ' : ''}${this.formModel.fatherName ?
        this.formModel.fatherName + ' ' : ''}${this.formModel.grandFatherName ? this.formModel.grandFatherName + ' ' : ''}${this.formModel.familyName ? this.formModel.familyName : ''}`;
      this.$set(this.formModel, 'fullname', fullname || []);
      this.$emit('updateItem', this.formModel);
      this.formModel = {};
    },
    onClose(e) {
      this.$emit('onClose');
      this.resetForm();
    },
    close() {
      this.onClose();
      this.$refs.addConcernedOfMinor.close();
    },
    show() {
      this.$refs.addConcernedOfMinor.show();
    },
    resetForm() {
      this.formModel = {};
      this.$refs.concernedOfMinorPersonalInfo.firstBirthDateChangeOccurred = false;
    },
  },
};
</script>

